module.exports = __webpack_public_path__ + "img/slider-foto5.ea4d34ec.png";